<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Find a Vet</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <app-location-picker (locationSet)="findVets($event)" #locationPicker></app-location-picker>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-item lines="none" color="lightmimbo" class="toggle-item">
          <ion-label>Only show vets currently open</ion-label>
          <ion-toggle [(ngModel)]="showOpenNow" slot="end" (ionChange)="locationPicker.getUserLocation()"></ion-toggle>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="isLocationSelected && !isLoading" class="ion-text-center">
      <ion-col>
        <ion-card *ngFor="let vet of vetsDetails" class="vet-card post">
          <ion-card-header>
            <ion-card-title color="primary">{{vet.name}}</ion-card-title>
            <ion-card-subtitle *ngIf="vet.rating" color="primary">Rating: {{vet.rating + "/5"}} (based on
              {{vet.ratingsTotal}}
              ratings)
            </ion-card-subtitle>
            <ion-card-subtitle *ngIf="!vet.rating" color="primary">No rating available</ion-card-subtitle>

            <ion-text *ngIf="vet.isOpen === true" color="success" class="open-status"><span
                class="status-dot open"></span> Open
              Now</ion-text>
            <ion-text *ngIf="vet.isOpen === false" color="danger" class="open-status"><span
                class="status-dot closed"></span> Closed
              Now</ion-text>
            <div class="top-vet-badge" *ngIf="vet.rating >= 4.5 && vet.ratingsTotal >= 50">
              <span class="top-badge-icon">★</span>
              <div class="badge-text">
                <strong>Top Rated Vet</strong>
              </div>
            </div>
            <div class="silver-vet-badge" *ngIf="vet.rating >= 4.2 && vet.rating < 4.5 && vet.ratingsTotal >= 50">
              <span class="silver-badge-icon">★</span>
              <div class="badge-text">
                <strong>Highly Rated Vet</strong>
              </div>
            </div>
          </ion-card-header>
          <ion-card-content>
            <ion-button fill="clear" size="small" (click)="goToDirections(vet.location)"><ion-icon
                name="compass-outline" slot="start"></ion-icon><ion-text>Directions</ion-text></ion-button>
            <ion-button *ngIf="vet.website" size="small" fill="clear" (click)="goToWebsite(vet.website)"><ion-icon
                name="globe-outline" slot="start"></ion-icon><ion-text>Website</ion-text></ion-button>
            <ion-button *ngIf="vet.phoneNumber" size="small" fill="clear" [href]="'tel:'+ vet.phoneNumber"><ion-icon
                name="call-outline" slot="start"></ion-icon><ion-text>{{vet.phoneNumber}}</ion-text></ion-button>
            <ion-button *ngIf="vet.openingHours" size="small" fill="clear" (click)="viewOpeningHours(vet)"><ion-icon
                name="time-outline" slot="start"></ion-icon><ion-text>Opening Hours</ion-text></ion-button>
            <ion-button *ngIf="vet.reviews" size="small" (click)="ReadReviews(vet)" fill="clear"><ion-icon
                name="reader-outline" slot="start"></ion-icon><ion-text>Read Top Reviews</ion-text></ion-button>
          </ion-card-content>
        </ion-card>
        <div *ngIf=" vetsDetails.length <= 0" class="ion-text-center ion-padding">
          <ion-text>No vets near this location are found.</ion-text>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <div *ngIf="!isLocationSelected && !isLoading" class="ion-text-center ion-padding">
          <ion-text>Select a location to find vets near you.</ion-text>
        </div>
        <div *ngIf="isLocationSelected && isLoading" class="ion-text-center ion-padding">
          <ion-spinner color="primary"></ion-spinner>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>